import { Select } from 'antd';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

type Order = 'ASC' | 'DESC' | 0 | 1;

interface OrderExtraFilter {
  value?: Order;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value?: any) => void;
  optionsValue?: {
    asc: number | string;
    desc: number | string;
  };
  placeholder?: ReactNode;
}

function OrderExtraFilter({
  value,
  onChange,
  optionsValue = { asc: 'ASC', desc: 'DESC' },
  placeholder,
}: OrderExtraFilter) {
  return (
    <Select
      allowClear
      value={value}
      onChange={onChange}
      style={{ width: '100%' }}
      placeholder={
        placeholder || <FormattedMessage id="customers.filters.order" />
      }
    >
      <Select.Option value={optionsValue.asc}>
        <FormattedMessage id="customers.filters.order.options.asc" />
      </Select.Option>
      <Select.Option value={optionsValue.desc}>
        <FormattedMessage id="customers.filters.order.options.desc" />
      </Select.Option>
    </Select>
  );
}

export default OrderExtraFilter;
